export default "__VITE_ASSET__thddtiSJ__"